import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';

import { PresenterType } from '@app/shared';
import { ExportReadyModel } from './export-ready.model';

@PresenterType({
  model: ExportReadyModel,
})

@Component({
  selector: 'export-ready-message',
  standalone: false,
  templateUrl: './export-ready-message.component.html',
  styleUrl: './export-ready-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExportReadyMessageComponent {

  public data: WritableSignal<ExportReadyModel> = signal<ExportReadyModel>(null);
}
